import { render, staticRenderFns } from "./analytics.vue?vue&type=template&id=5afa4bb6&scoped=true&"
import script from "./analytics.vue?vue&type=script&lang=js&"
export * from "./analytics.vue?vue&type=script&lang=js&"
import style0 from "./analytics.vue?vue&type=style&index=0&id=5afa4bb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afa4bb6",
  null
  
)

export default component.exports